<template>
  <v-flex xs12 sm6>
    <v-card class="border">
      <div class="tituloBox p-l-15">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-18">Não Tenho <strong>Cadastro</strong></h1>
      </div>
      <v-form v-model="valid" lazy-validation ref="formCadastro">
        <v-layout row wrap class="radiosLogin">
          <v-flex xs12 sm5>
            <v-radio-group v-model="model.flagEstrangeiro" class="mb-0">
              <v-radio label="Brasileiro" value="0"></v-radio>
              <v-radio label="Estrangeiro" value="1"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm7>
            <v-radio-group v-model="model.tipFornecedor" class="mb-0">
              <v-radio :label="$t('label.pessoaJurica')" value="J"></v-radio>
              <v-radio :label="$t('label.pessoaFisica')" value="F"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              maxlength="18"
              v-if="model.flagEstrangeiro == 0 && model.tipFornecedor =='J'" 
              key="num_CgcFornecedorCommMaskPJ" 
              v-model="num_CgcFornecedor" 
              :label="$t('label.cnpj') +' *'" 
              v-mask="maskCnpj" 
              :rules="validacao.cnpj"
              @input="toUpperCase"
              required>
            </v-text-field>
            <v-text-field maxlength="14" v-if="model.flagEstrangeiro == 0 && model.tipFornecedor =='F'" key="num_CgcFornecedorCommMaskPF" v-model="num_CgcFornecedor" :label="$t('label.cpf')+' *' " 
              v-mask="maskCpf" 
              :rules="validacao.cpf"
              required>
            </v-text-field>
            <v-text-field maxlength="14" v-if="model.flagEstrangeiro == 1" key="num_CgcFornecedorSemMask" v-model="num_CgcFornecedor" :label="(model.tipFornecedor =='J') ? $t('label.registro')+' *' : $t('label.documentoIdentificacao')+' *'"
            v-mask="maskEstrangeiro"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <v-text-field maxlength="70" v-model="model.nomFornecedor" :label="(model.tipFornecedor =='J') ? $t('label.razaoSocial')+' *' : $t('label.nome')+' *' " :rules="validacao.campoObrigatorio" required></v-text-field>
          </v-flex>
        </v-layout>  
        <!-- Novo Campo Celular -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              maxlength="19"
              v-model="model.celular"
              :label="$t('label.celular') + ' *'"
              :rules="[validaCelular]"
              v-mask="'+## ###########'"
              required
              autocomplete="off"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <!-- Campo E-mail -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field maxlength="50" v-model="model.endEmail" :label="$t('label.email')+' *'" :rules="validacao.email" required></v-text-field>
          </v-flex>
        </v-layout>
        <!-- Campo Confirme o E-mail -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field 
              maxlength="50" 
              v-model="repitaEmail"
              :label="$t('label.confirmeEmail') + ' *'"
              :rules="[validaEmailIgual() || msgEmailDiferente]"
              required
              @paste.prevent
              autocomplete="off">
            </v-text-field>
          </v-flex>
        </v-layout>
        <!-- Campos Senha e Repita Senha -->  
        <v-layout row>
          <v-flex xs12 sm6>
            <v-text-field type="password" v-model="model.senha" :label="$t('label.senha')+' *'" :rules="validacao.validAlphaNumericCaracter" :hint="$t('messages.validacao.alphaNumericCaracter')" persistent-hint required></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field type="password" v-model="repitaSenha" :label="$t('label.repitaSenha')+' *'" :rules="[validaSenhaIguais() || msgRepitaSenha]" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <v-layout row>
          <v-flex xs12 sm12 >
            <v-checkbox :rules="validacao.campoObrigatorio" v-model="chkPopUp" required v-on:change="abrirPopUp()">
                <div slot="label">
                 <a @click='abrirTermos()' href="javascript:void(0)">Termo de Concordância e Veracidade</a>.
                </div>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12 p-b-15 p-t-10>
            <v-btn large color="info" @click="cadastrar()">Cadastrar Fornecedor</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
       <v-dialog v-model="dialogPop" persistent width="50%">
        <v-card>          
          <v-card-text>
            "Prezado Senhor Fornecedor,
            <br><br>
            A realização do cadastro como fornecedor ativo no Cadastro Unificado de Fornecedores do Estado da Bahia – CAF e a entrega deste documento importa na aceitação de todos os termos e condições que regem o Cadastro de Fornecedores.
            <br><br>
            Se obriga o fornecedor a entregar o Termo de Concordância e veracidade do Comprasnet.Ba nos Postos de Serviços de Atendimento ao Fornecedores - SAF localizados em Salvador e municípios do interior do Estado da Bahia.
            <br><br>
            O prazo para análise da documentação encaminhada será de 3(dias) úteis a contar da data de recebimento do <b>Termo de Concordancia Veracidade do Comprasnet.Ba"</b>
            <br><br>
            <b>Secretaria da Administração
            <br> Superintendência de Recursos Logísticos - SRL
            <br> Diretoria de Suporte à Logística - DSL
            <br> Coordenação de Gestão de Cadastro de Fornecedores - CGCF
            <br> Telefone: 3115-3211 </b>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="dialogPop = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" persistent width="90%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Concordância e veracidade</v-card-title>
          <v-card-text>
            A realização do registro como fornecedor (pessoa física ou jurídica, nacional ou estrangeira) ativo no Cadastro Unificado de Fornecedores do Estado da Bahia - CAF e a entrega deste documento, importa na aceitação de todos os termos e condições que regem o Cadastro Unificado de Fornecedores do Estado da Bahia - CAF, conforme Lei Estadual nº 9.433, de 01 de março de 2005 e demais instrumentos legais vigentes, admitindo como válida a assinatura eletrônica cadastrada (login/senha).
            <br><br>
            Ao submeter a solicitação, o fornecedor (pessoa física ou jurídica, nacional ou estrangeira) admite-se como responsável pelas ações efetuadas no Comprasnet.BA, bem como atesta a veracidade de todos os documentos enviados, concordando em que havendo condutas suspeitas de irregularidades, as mesmas serão passíveis de apuração de ilícito civil, penal e administrativo.
            <br><br>
            Ainda, declara que o endereço informado refere-se a atual localização do fornecedor (pessoa física ou jurídica, nacional ou estrangeira), e assume exclusivamente a responsabilidade por:
            <br><br>
            I.  Manter em sigilo a senha de acesso, não cabendo, em qualquer hipótese, alegação de uso indevido;
            <br>
            II.  Conformidade entre os dados informados no formulário de solicitação de cadastro e os constantes do documento protocolizado, incluindo o preenchimento dos campos obrigatórios e anexação dos documentos essenciais complementares;
            <br>
            III.  Preenchimento da solicitação do cadastro e o upload dos documentos digitais em conformidade com os requisitos estabelecidos pelo Sistema, no que se refere ao formato e ao tamanho dos arquivos transmitidos eletronicamente;
            <br>
            IV.  Manutenção das vias originais dos documentos digitalizados enviados na solicitação do cadastro eletrônico, para que, caso solicitado, sejam apresentados para qualquer tipo de conferência pela Administração;
            <br>
            V.  Realização por meio eletrônico de todas as atualizações e comunicações entre o órgão/entidade responsável e o usuário, não sendo admitidas protocolização por meio diverso, exceto nas situações em que for tecnicamente inviável ou em caso de indisponibilidade do meio eletrônico cujo prolongamento cause dano relevante à celeridade do processo ou outra exceção prevista em instrumento normativo próprio;
            <br>
            VI.  Acompanhamento, por meio do protocolo eletrônico da solicitação do cadastro e/ou atualização dos documentos transmitidos eletronicamente;
            <br>
            VII.  Assumir as condições de navegabilidade e segurança da rede de comunicação, o acesso ao provedor de internet e as configurações do computador utilizado nas transmissões eletrônicas;

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="dialog = false">Eu aceito</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogApresentacao" width="90%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Apresentação</v-card-title>
          <v-card-text>              
            <h2><b>Bem-Vindo ao Cadastro Unificado de Fornecedores do Estado da Bahia – CAF</b></h2>	
            <br />
            <p style="text-align:justify;">                
              O Cadastro Unificado de Fornecedores do Estado da Bahia - CAF é um sistema informatizado que gerencia, mantém e controla, de forma unificada, o cadastro de fornecedores. Atualmente o CAF é gerido pela Superintendência de Recursos Logísticos por intermédio da Coordenação de Gestão do Cadastro de Fornecedores – CGCF/DSL/SRL a qual compõe a estrutura da Secretaria da Administração do Estado da Bahia – SAEB.
              <br /><br />
              A Comissão de Cadastro tem a função de proceder ao exame dos documentos apresentados por pessoas físicas ou jurídicas interessadas em participar de licitações e celebrar contratos com os órgãos e entidades da Administração Pública Estadual para manutenção do CAF, visando proporcionar maior celeridade na habilitação nos procedimentos licitatórios, e subsidiar os órgãos/entidades nas contratações.
              <br /><br />
              O CAF disponibiliza três opções de inscrição conforme segue:
              <br /><br />
              1.<b> Certificado de Registro Cadastral – CRC</b>: Certificado que pré-habilita, de forma genérica, o fornecedor a participar de qualquer modalidade de licitação, desde que possua o código de família exigido no edital.  
              <br />
              <br />
              2.<b> Certificado de Registro Simplificado – CRS</b>: Certificado que pré-habilita, de forma genérica, o fornecedor a participar de licitação, desde que possua o código de família exigido no edital, fazendo-se necessária a apresentação de documentação complementar, a depender da modalidade de licitação. 
              <br />
              <br />
              3.<b> Credenciamento para Cotação Eletrônica (Candidato)</b>: Procedimento que autoriza e credencia o fornecedor para participar de cotações eletrônicas.
                              
            </p>	
          </v-card-text>
          <v-card-title class="headline grey lighten-2">Identificação do Representante Legal</v-card-title>
          <v-card-text>
            <v-form v-model="valid" lazy-validation ref="formCadastrador">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="50" v-model="model.nomCadastrador" :label="$t('label.nome') + ' *' " :rules="validacao.campoObrigatorio" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field v-if="model.flagEstrangeiro != 1" v-model="model.cpfCadastrador" :label="$t('label.cpf')+' *' "  v-mask="maskCpf"  :rules="validacao.cpf" required></v-text-field>
                  <v-text-field v-else v-model="model.cpfCadastrador" :label="$t('label.passaporte')+' *' " v-mask="maskDocumentoIdentificacao" maxlength="14" :rules="validacao.campoObrigatorio" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field v-model="model.rgRepresentanteLegal" :label="$t('label.documentoIdentificacao') + ' (' + $t('label.documentosValidosIdentificacao') + ') *'"  v-mask="maskAlfaNumRG" :rules="validacao.campoObrigatorio" required> </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12> 
                  <v-text-field maxlength="50" v-model="model.emailRepresentanteLegal" :label="$t('label.email') + ' *'" :rules="validacao.email" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-show="model.tipFornecedor == 'J'">
                <v-flex xs12>
                  <v-text-field
                    v-model="model.razaoSocialRepresentanteLegal"
                    :label="$t('label.razaoSocial')"
                    :disabled=true>
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="model.tipFornecedor == 'J'">
                <v-flex xs12>
                  <v-text-field 
                    v-if="model.tipFornecedor == 'J' && model.flagEstrangeiro == '0'"
                    v-model="model.cnpjRepresentanteLegal" 
                    :label="$t('label.cnpj')"
                    v-mask="maskCnpj"
                    :disabled=true>
                  </v-text-field>
                  <v-text-field 
                    v-else
                    v-model="model.cnpjRepresentanteLegal" 
                    :label="$t('label.registro')"
                    :disabled=true>
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- CEP com consulta ao webservice -->
              <v-layout row>
                <v-flex xs12>                  
                  <v-text-field
                    v-model="model.cepRepresentanteLegal"
                    :label="$t('label.cep') + ' *' " 
                    v-mask="maskCEP"                    
                    :rules="validacao.campoObrigatorio" 
                    required
                    @blur="viaCEP()"
                    @focus="limpaCEP()"             
                  >
                  </v-text-field>
                  <div
                    v-if="validEventCEP"
                    class="msgCEP v-messages v-messages__message theme--light error--text"              
                  >
                    {{ this.msgCEP }}
                  </div>
                </v-flex>
              </v-layout>
              <!-- / CEP com consulta ao webservice -->

              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="50" v-model="model.EnderecoRepresentanteLegal" :label="$t('label.endereco') + ' *' "> </v-text-field>
                </v-flex>
              </v-layout> 
              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="100" v-model="model.bairroRepresentanteLegal" :label="$t('label.bairro') + ' *' "></v-text-field>
                </v-flex>
              </v-layout>
             <v-layout row>
                <v-flex xs12>
                  <v-autocomplete
                    v-if="model.flagEstrangeiro == 0"
                    v-model="model.estadoRepresentanteLegal"
                    :items="listaEstado"
                    :label="$t('label.estado') + ' *'"
                    item-text="nom_uf"
                    item-value="cod_uf"
                    :rules="validacao.campoObrigatorio"
                    @change="listaCidade = []"
                    :hint="ifValueAlterado(model.estadoRepresentanteLegal, 'estadoRepresentanteLegal')"
                    persistent-hint
                  ></v-autocomplete>
                  <v-text-field
                    v-if="model.flagEstrangeiro == 1"
                    maxlength="40"
                    v-model="model.estadoRepresentanteLegal"
                    :label="$t('label.estado') + ' *'"
                    :rules="validacao.campoObrigatorio"
                    :hint="
                      ifValueAlterado(model.estadoRepresentanteLegal, 'estadoRepresentanteLegal')
                    "
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>              
              <v-layout row>
                <v-flex xs12>
                  <v-autocomplete
                    v-if="model.flagEstrangeiro != 1"
                    v-model="model.cidadeRepresentanteLegal"
                    :items="listaCidade"
                    :label="$t('label.cidade') + (model.estadoRepresentanteLegal !== 'DF' ? ' *' : '')"
                    item-text="desc_municipio"
                    item-value="desc_municipio"
                    :rules="validaCidade(model.estadoRepresentanteLegal)"
                    :clearable="true"
                    :loading="isLoadCombo"
                    :search-input.sync="pesquisaCidade"
                    :hint="ifValueAlterado(model.endCidade, 'endCidade')"
                    persistent-hint
                  ></v-autocomplete>
                  <v-text-field
                    v-else
                    maxlength="50"
                    v-model="model.cidadeRepresentanteLegal"
                    :label="$t('label.cidade')"
                    required
                    :hint="
                      ifValueAlterado(
                        model.cidadeRepresentanteLegal,
                        'cidadeRepresentanteLegal'
                      )
                    "
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field 
                      v-model="model.celular"
                      :label="$t('label.celular') + ' *'"
                      :rules="[validaCelular]"
                      v-mask="'+## ###########'"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
               <v-layout row>
                <v-flex xs12>
                  <v-text-field v-model="model.telRepresentanteLegal" :label="$t('label.telefone')"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>       
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" :disabled="disabled" @click="fecharApresentacao()">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-flex>
</template>

<script>
  import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
  import dominioService from "../../../services/dominioService";
  import loginService from "../../../services/loginService";
  import analiseCampoAlterado from "../../area-restrita/fornecedor/components/analiseCampoAlterado";
  import axios from "axios";
  export default {
    props: {
      rules: Array,
      isAlteracao: Boolean,
      disabled: { // Definição da prop disabled
      type: Boolean,
      default: false,
    },
    },
    name: "CadastroForm",
    mixins: [util, analiseCampoAlterado],
    created() {
      this.getCombosDadosBasicos();
    },     
    data() {//Declaracao de variaveis
    
      return {
        valid: true,
        model: {
          isBrasileiro: true,
          isEstrangeiro: false,
          tipFornecedor: "J",
          flagEstrangeiro: "0",
          flagSociedadeAnonima: "0", 
          campoHiddenCEP: "",
          EnderecoRepresentanteLegal: "",  
          cidadeRepresentanteLegal: null,
          celular: "+55", // DDI do Brasil preenchido automaticamente        
        },
        
        num_CgcFornecedor:null,
        repitaSenha: "",
        repitaEmail: "", // Novo campo adicionado        
        recuperar: null,
        msgRepitaSenha: this.$t("messages.validacao.senhasDiferentes"),
        msgEmailDiferente: this.$t("messages.validacao.emailsDiferentes"), // Nova mensagem
        dialog: false,
        dialogApresentacao: false,
        localDisabled: this.disabled,     
        chkPopUp: false,
        dialogPop: false,
        pesquisaCidade: null,
        listaEstado: [],
        listaCidade: [],
        isLoadCombo: false,
        baseUrlCEP: "https://viacep.com.br/ws/",        
        msgCEP: "",
        validEventCEP: false,
        cepNaoEnc: "CEP não encontrado.",
      };
    },
    computed: {//Campos computados
      maskEstrangeiro() {
        let str = "";
        let i = 0;
        for ( ; i < 30; i++) {
          str += "X";
        }
        
        return [str];
      }
    },
    watch: {
      pesquisaCidade(newValor, oldValor) {
        this.pesquisaCombo(
          newValor,
          oldValor,
          "listaCidade",
          eval("this.listaCidade"),
          "model.desc_municipio",
          this.getCidade
        );
      },

      "model.cidadeRepresentanteLegal": {
        //se a cidade mudar
        handler(newValue, oldValor) {
          if (this.model.flagEstrangeiro !== "1") {
            // flagEstrangeiro é um tipo string
            this.getCidade(newValue);
          }
          if (
            oldValor &&
            oldValor !== newValue &&
            this.model.tipFornecedor === "J"
          ) {
            if (this.isAlteracao) {
              this.limpaCampo(["arquivoUpload", "datExpedicao"]);
            }
          }
        },
      },


    },
    methods: {//Declaracao de todos os metodos
    toUpperCase(value) {
      if (value) {
        this.num_CgcFornecedor = value.toUpperCase();
      }
    },
      cadastrar() {
        if (this.$refs.formCadastro.validate()) {

          // Processar o número de celular
          if (this.model.celular) {
            this.model.celular = this.model.celular.replace(/[\s-]/g, ''); // Remove espaços e hífens
            // Validar comprimento após remoção
            if (this.model.celular.length < 10 || this.model.celular.length > 15) {
              this.$toasted.error(this.$t("messages.validacao.celularInvalido"));
              return;
            }
          } else {
            this.$toasted.error(this.$t("messages.validacao.campoObrigatorio"));
            return;
          }

          // Validar se os e-mails coincidem
          if (this.model.endEmail !== this.repitaEmail) {
            this.$toasted.error(this.$t('messages.validacao.emailsDiferentes'));
            return;
          }

          const cgcForneceror = this.num_CgcFornecedor;
          if (this.model.flagEstrangeiro === '0') {
            this.model.numCgcFornecedor = this.num_CgcFornecedor.replace(/[\W_]+/g, '');
          } else {
            this.model.numCgcFornecedor = this.num_CgcFornecedor;
          }

          if (this.model.tipFornecedor === "F") {
            this.model.nomFantasia = this.model.nomFornecedor;
          } else {
            this.model.cnpjRepresentanteLegal = cgcForneceror;
            this.model.razaoSocialRepresentanteLegal = this.model.nomFornecedor;
          }

          // **Incluir o campo "Celular" na requisição**
          this.model.CelularRepresentanteLegal = this.model.celular;

          loginService.validarcadastroinicial(this.model).then(response => { /*resposta do servico*/
            this.mostrarApresentacao();
          });
        }
      },
      mostrarApresentacao(){
        this.dialogApresentacao = true;
      },
      fecharApresentacao(){
        if (this.$refs.formCadastrador.validate()) {
          this.$mostrarPreload(); /*Exibir o PreLoad*/
          this.localDisabled = true;
          this.model.cpfCadastrador = this.model.cpfCadastrador.replace(/[^A-Z0-9]/gi, '');

          // **Incluir o campo "Celular" na requisição**
          this.model.CelularRepresentanteLegal = this.model.celular;
          console.log("PASSOUAQUICADASTRO");
          loginService.cadastroinicial(this.model).then(response => { /*resposta do servico*/
            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

            this.dialogApresentacao = false;
            this.$toasted.success(this.$t('messages.cadastro.sucesso'));
            this.$router.push("/cadastro");
            

            this.localDisabled = false;
          }).catch(() => {
            this.localDisabled = false;
          });
        }
      },
      validaEmailIgual() {
        return this.model.endEmail === this.repitaEmail;
      }, // Novo método
      validaSenhaIguais() {
        if (this.model.senha !== this.repitaSenha) {
          if (!this.repitaSenha) {
            this.msgRepitaSenha = this.$t("messages.validacao.campoObrigatorio")
          } else {
            this.msgRepitaSenha = this.$t("messages.validacao.senhasDiferentes")
          } 
          return false
        }
        return true;
      },

      validaCelular(value) {
        // Regex para validar números no formato internacional (+DDI seguido de 9 a 13 dígitos)
        const regex = /^\+\d{1,3} \d{9,13}$/; // Ex.: +55 71999999999
        return regex.test(value) || this.$t("messages.validacao.celularInvalido");
      },

      abrirTermos() {
      
        this.dialog = true;
      },
      getCombosDadosBasicos() {
        loginService.getCombosDadosBasicos().then((response) => {
          this.listaEstado = response.data.uf;
          this.listaPais = response.data.paises;
        });
      },
      getCidade(valor) {
        this.isLoadCombo = true;

        let cidade = { cod_uf: this.model.estadoRepresentanteLegal, desc_municipio: "" };
        
        loginService.getCidade(cidade).then((response) => {
          this.listaCidade = response.data; /*dados de retorno*/
          this.isLoadCombo = false;
        });
      },       
      abrirPopUp() {
       
        if (this.chkPopUp == true && this.dialog == false) {
          this.dialog = true;
        }
      },
      validaCidade(estado){
        return estado !== 'DF' ? this.validacao.campoObrigatorio : [];
      },
      limpaCEP() {
        this.validEventCEP = false
      },
      viaCEP() {
        if (this.model.cepRepresentanteLegal){
          const setCEP = this.model.cepRepresentanteLegal.replace("-", "").replace(".", ""); // Removendo máscara de CEP 
          const urlCEP = `${this.baseUrlCEP}${setCEP}/json/`;        
          axios.get(urlCEP).then(resp => {
            const data = resp.data
            if (!data.erro) {
              this.model.EnderecoRepresentanteLegal = data.logradouro,
              this.model.bairroRepresentanteLegal = data.bairro,
              this.model.cidadeRepresentanteLegal = data.localidade,
              this.model.estadoRepresentanteLegal = data.uf            
            } else {            
              this.validEventCEP = true
              this.msgCEP = "CEP não encontrado";
              this.model.EnderecoRepresentanteLegal = null,
              this.model.bairroRepresentanteLegal = null,
              this.model.cidadeRepresentanteLegal = null,
              this.model.estadoRepresentanteLegal = null 
            }
          }).catch(error => {
            console.error(error)
            this.validEventCEP = true;
            this.msgCEP = "CEP inválido";
            this.limpaCEP;          
          })
        }
      }
    }
  };
</script>
<style>
.msgCEP {
  position: relative !important;
  top: -10px !important;
  margin-bottom: -13px !important;
}
</style>